import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { whatsappKeys } from "@/lib/query-keys";
import type { WhatsappStatus } from "@/types/domain";

/** Activo = verificado y sin baja. Darse de baja no borra la verificación. */
export function isWhatsappActive(status?: WhatsappStatus): boolean {
  return !!status?.verified && !status.optedOut;
}

/**
 * Estado del canal de WhatsApp. `poll` lo refresca cada 5s mientras no esté
 * activo: la activación ocurre fuera de la app (el usuario nos escribe) y así la
 * pantalla pasa sola a "activo" cuando llega su mensaje.
 *
 * Ambos flags los pone quien lo monta porque el sondeo es caro: dejarlo prendido
 * de fondo llenaba `apiactivitylog` de un usuario que no está esperando nada.
 */
export function useWhatsappStatus({
  enabled = true,
  poll = enabled,
}: { enabled?: boolean; poll?: boolean } = {}) {
  return useQuery({
    queryKey: whatsappKeys.status,
    enabled,
    queryFn: () =>
      fetchToBackend<WhatsappStatus>("/userextrainformation/whatsapp"),
    // Mirar solo `verified` dejaba colgado a quien se dio de baja: sigue
    // verificado, así que el sondeo nunca arrancaba y su reactivación no se veía.
    refetchInterval: (query) =>
      poll && !isWhatsappActive(query.state.data) ? 5000 : false,
  });
}
